import React from 'react'
import MaterialSymbol from '../material-symbol'

const Phone = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="phone" {...props} />
))

Phone.displayName = 'Phone'

export default Phone
